import OccupancyMain from './occupancy/occupancy-main';

(function() {
    window.RoiEngineWidgetOccupancies = {
        create: (engineForm, isCorporate, initialAdults = undefined) => {
            const initial = {},
                adults = new URL(window.location.href).searchParams.get('adults'),
                childrenAges = new URL(window.location.href).searchParams.get('children-ages');

            if (adults) {
                initial.adults = parseInt(adults, 10);
            } else if (initialAdults) {
                initial.adults = initialAdults;
            }

            if (childrenAges) {
                initial.ages = childrenAges.replaceAll(',', ';');
                initial.children = childrenAges.split(',').length;
            }
            new OccupancyMain(engineForm, isCorporate, initial);
        }
    };
}());
